import { useLanguage } from '../contexts/LanguageContext';
export default function AuthLanguageSelect(){
 const {language,setLanguage,supportedLanguages}=useLanguage();
 const label={es:'Idioma',en:'Language',pt:'Idioma',fr:'Langue'}[language]||'Language';
 return <label className="bc-auth-language"><span>{label}</span><select aria-label={label} value={language} onChange={e=>setLanguage(e.target.value)}>{supportedLanguages.map(item=><option key={item.code} value={item.code}>{item.name}</option>)}</select></label>;
}
